import React from 'react';
import {Drawer} from 'antd';
import {FormattedMessage, useIntl} from 'react-intl';
import {
    ExportOutlined,
    FileProtectOutlined,
    FileSyncOutlined,
    FileTextOutlined,
    MessageOutlined,
    SafetyOutlined,
} from '@ant-design/icons';
import {DentobookApplicationContext} from '../../context/DentobookApplicationContext';
import {isMobileOnly} from 'react-device-detect';

interface Props {
    open: boolean;
    onClose: () => void;
}

const HelpLegalDrawer: React.FC<Props> = ({open, onClose}) => {
    const {locale} = React.useContext(DentobookApplicationContext);
    const intl = useIntl();
    const lang = locale.toLowerCase();

    const sections: {
        icon: React.ReactNode;
        labelId: string;
        href: string;
        bold?: boolean;
    }[] = [
        {
            icon: <MessageOutlined style={{color: '#3862EE', fontSize: 16}}/>,
            labelId: 'report_problem',
            href: `https://dentobook.com/${lang}/contact-us/`,
            bold: true,
        },
        {
            icon: <MessageOutlined style={{color: '#3862EE', fontSize: 16}}/>,
            labelId: 'send_feedback',
            href: `https://dentobook.com/${lang}/contact-us/`,
            bold: true,
        },
        {
            icon: <FileSyncOutlined style={{color: '#6b7280', fontSize: 16}}/>,
            labelId: 'cookies_policy',
            href: `https://dentobook.com/${lang}/cookie-policy/`,
        },
        {
            icon: <FileTextOutlined style={{color: '#6b7280', fontSize: 16}}/>,
            labelId: 'usage_rules',
            href: `https://dentobook.com/${lang}/terms-of-use/`,
        },
        {
            icon: <FileProtectOutlined style={{color: '#6b7280', fontSize: 16}}/>,
            labelId: 'terms_and_conditions',
            href: `https://dentobook.com/${lang}/terms-and-conditions/`,
        },
        {
            icon: <SafetyOutlined style={{color: '#6b7280', fontSize: 16}}/>,
            labelId: 'gdpr',
            href: `https://dentobook.com/${lang}/gdpr/`,
        },
    ];

    return (
        <Drawer
            title={<FormattedMessage id="help_legal"/>}
            placement="right"
            width={isMobileOnly ? '100vw' : 360}
            open={open}
            onClose={onClose}
            aria-label={intl.formatMessage({id: 'help_legal'})}
        >
            <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                {sections.map((item, idx) => (
                    <li key={idx} style={{marginBottom: 4}}>
                        <a
                            href={item.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                padding: '10px 12px',
                                borderRadius: 8,
                                color: '#3B4863',
                                textDecoration: 'none',
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: 14,
                                fontWeight: item.bold ? 600 : 400,
                                transition: 'background 0.15s',
                            }}
                            onMouseEnter={e => (e.currentTarget.style.background = '#f5f7ff')}
                            onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
                        >
                            <span style={{flexShrink: 0}}>{item.icon}</span>
                            <span style={{flex: 1}}><FormattedMessage id={item.labelId}/></span>
                            <ExportOutlined style={{fontSize: 11, color: '#9ca3af', flexShrink: 0}}/>
                        </a>
                    </li>
                ))}
            </ul>
        </Drawer>
    );
};

export default HelpLegalDrawer;
